import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Checkout from './pages/Checkout';
import ThankYou from './components/thankyou';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { CartProvider } from './context/CartContext';
import { UserProvider } from './context/UserContext';

function App() {
  const [ping, setPing] = useState(null);

  useEffect(() => {
    fetch('http://localhost:8000/ping')
      .then((res) => res.json())
      .then((data) => {
        setPing(data.message);
      })
      .catch(() => setPing('Backend not reachable'));
  }, []);

  return (
    <CartProvider>
      <UserProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/thankyou" element={<ThankYou />} />
          </Routes>
          <Footer />
        </Router>
        <div
          style={{
            fontFamily: 'sans-serif',
            textAlign: 'center',
            marginTop: '2rem',
          }}
        >
          <h2>FastAPI Backend Status</h2>
          <p>
            {ping === null
              ? 'Checking backend...'
              : `Backend says: ${ping}`}
          </p>
        </div>
      </UserProvider>
    </CartProvider>
  );
}

export default App;
